export default {"src":"/_next/static/image/public/images/ic_call_footer.0d5ae131e9d57eee1a7040bbdfa1389b.svg","height":17,"width":17};